<template>
	<div>
		<v-row>
			<v-col cols="12">
				<div class="text-h5">
					لطفا فایل اکسل مورد نظر خود را با رعایت ترتیب ستون ها مطابق با فایل الگوی زیر، انتخاب کنید.
				</div>
				<div class="blue--text text-center mt-2">
					<a href="/statics/Jetaqsaat-excel-import-sample.xlsx">دانلود فایل الگو</a>
				</div>
			</v-col>
		</v-row>
		<v-form ref="form" lazy-validation>
			<v-row align="center" justify="center">
				<v-col cols="12" sm="5">
					<v-file-input ref="file" v-model="file" :rules="[value => !!value || 'ابتدا فایل را انتخاب کنید.']" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" placeholder="" prepend-icon="mdi-file-excel-outline" label="جهت انتخاب فایل اینجا را کلیک کنید" />
				</v-col>
				<v-col cols="12" sm="2">
					<v-btn color="info" dark :loading="previewLoading" @click="preview">
						<v-icon dark>
							mdi-upload
						</v-icon>
						بارگذاری و پیش نمایش
					</v-btn>
				</v-col>
			</v-row>
		</v-form>
		<v-row v-if="localData.importPreviewModels.length > 0" class="mt-3">
			<v-col cols="12" style="max-height:350px; overflow-y:auto">
				<div class="text-h5 primary--text text-center mt-3 mb-3">
					لطفا پیش نمایش اطلاعات را بررسی کنید و در صورت تایید، بر روی دکمه تایید (پایین جدول) کلیک کنید.
				</div>
				<v-data-table :headers="headers" :items="localData.importPreviewModels" :items-per-page="500" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="primary--text">
								{{ row.item.systemMsg }}
							</td>
							<td>{{ row.item.firstName }}</td>
							<td>{{ row.item.lastName }}</td>
							<td>{{ row.item.fatherName }}</td>
							<td>{{ row.item.mobile }}</td>
							<td>{{ row.item.phone }}</td>
							<td>{{ row.item.nationalCode }}</td>
							<td>{{ row.item.address }}</td>
							<td>{{ row.item.gender }}</td>
							<td>{{ row.item.regDate2 }}</td>
							<td>{{ row.item.birthDate }}</td>
							<td>{{ row.item.familiar1FirstName }}</td>
							<td>{{ row.item.familiar1LastName }}</td>
							<td>{{ row.item.familiar1Mobile  }}</td>
							<td>{{ row.item.familiar2FirstName }}</td>
							<td>{{ row.item.familiar2LastName }}</td>
							<td>{{ row.item.familiar2Mobile }}</td>
							<td>{{ row.item.agent }}</td>
						</tr>
					</template>
				</v-data-table>
				<div class="text-center pt-3">
					<v-btn color="info" dark :loading="submitLoading" @click="submit">
						<v-icon dark>
							mdi-upload
						</v-icon>
						تایید
					</v-btn>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="summery">
			<v-col cols="12">
				<div class="text-success">
					تعداد عضو ثبت شده: {{ summery.memberNew }}
				</div>
				<div class="text-success">
					تعداد عضو ویرایش شده: {{ summery.memberUpdate }}
				</div>
				<div v-if="summery.failed != 0" class="primary--text">
					تعداد ناموفق: {{ summery.failed }}
				</div>
				<div v-if="summery.errors.length > 0" class="primary--text">
					خطاها:
					<div v-for="err in summery.errors" :key="err">
						{{ err }}
					</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MemberImportView',
		data() {
			return {
				previewLoading: false,
				submitLoading: false,
				file: null,
				errorMessages: '',
				localData: {
					importPreviewModels: [],
				},
				headers: [
					{
						text: 'پیام سیستم',
						align: 'right',
						sortable: true,
						value: 'systemMsg',
						width: 200,
					}, {
						text: 'نام',
						align: 'right',
						sortable: true,
						value: 'firstName',
					}, {
						text: 'نام خانوادگی',
						align: 'right',
						sortable: true,
						value: 'lastName',
					}, {
						text: 'نام پدر',
						align: 'right',
						sortable: true,
						value: 'fatherName',
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'تلفن ثابت',
						align: 'center',
						sortable: true,
						value: 'phone',
					}, {
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'تاریخ تولد',
						align: 'center',
						sortable: true,
						value: 'birthDate',
					}, {
						text: 'آدرس',
						align: 'right',
						sortable: true,
						value: 'address',
					}, {
						text: 'جنسیت',
						align: 'center',
						sortable: true,
						value: 'gender',
					}, {
						text: 'تاریخ عضویت',
						align: 'center',
						sortable: true,
						value: 'regDate2',
					}, {
						text: 'نام معرف 1',
						align: 'right',
						sortable: true,
						value: 'familiar1FirstName',
					}, {
						text: 'نام خانوادگی معرف 1',
						align: 'right',
						sortable: true,
						value: 'familiar2LastName',
					}, {
						text: 'شماره تماس معرف 1',
						align: 'right',
						sortable: true,
						value: 'familiar1Mobile',
					}, {
						text: 'نام معرف 2',
						align: 'right',
						sortable: true,
						value: 'familiar2FirstName',
					}, {
						text: 'نام خانوادگی معرف 2',
						align: 'right',
						sortable: true,
						value: 'familiar2LastName',
					}, {
						text: 'شماره تماس معرف 2',
						align: 'right',
						sortable: true,
						value: 'familiar2Mobile',
					}, {
						text: 'نماینده',
						align: 'right',
						sortable: true,
						value: 'agent',
					}
				],
				summery: null,
			}
		},
		mounted() {
			console.log('mounted')
		},
		methods: {
			preview() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				const formData = new FormData()
				formData.append('file', this.file)
				this.previewLoading = true
				api.post('admin/import/MemberImportPreview', formData, { contentType: 'multipart/form-data' })
					.then(
						response => {
							this.localData.importPreviewModels = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.previewLoading = false })
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				this.submitLoading = true
				api.post('admin/import/MemberImportSubmit', this.localData)
					.then(
						response => {
							this.localData.importPreviewModels = []
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.summery = response
							this.$emit('upload')
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			prepareData() {
				this.localData.importPreviewModels = []
			},
		},
	}
</script>
<style>
</style>
